import React, { useEffect, useRef } from 'react';
import styles from './Cursor.module.css';

export type CursorProps = {
    textElement: string;
    hoverElement: string
}

const Cursor = (props: CursorProps) => {
    const mousePos = useRef({ x: 0, y: 0 });
    const innerRef = useRef<HTMLDivElement>(null);
    const outerRef = useRef<HTMLDivElement>(null);

    const outerPos = useRef({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            mousePos.current = { x: e.clientX, y: e.clientY };

            // Instant inner cursor update
            if (innerRef.current) {
                innerRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
            }
        };

        const animate = () => {
            // Easing factor (0.1 means slow, 1 means instant)
            const delay = 0.1;

            // Interpolate toward target
            outerPos.current.x += (mousePos.current.x - outerPos.current.x) * delay;
            outerPos.current.y += (mousePos.current.y - outerPos.current.y) * delay;

            // Apply outer cursor position
            if (outerRef.current) {
                outerRef.current.style.transform = `translate(${outerPos.current.x}px, ${outerPos.current.y}px) translate(-50%, -50%)`;
            }

            requestAnimationFrame(animate);
        };

        window.addEventListener('mousemove', handleMouseMove);
        animate();

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <>
            <div className={`${styles.outer} ${styles["outer_" + props.hoverElement]}` || `${styles.outer} ${styles.outer_cursor}`} ref={outerRef} />
            <div className={`${styles.inner} ${styles["inner_" + props.hoverElement]}` || `${styles.inner} ${styles.inner_cursor}`} ref={innerRef} ></div>
        </>
    );
};

export default Cursor;